package com.klantenstop.web.pages.categories

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.klantenstop.web.components.H1Heading
import com.klantenstop.web.components.H2Heading
import com.klantenstop.web.components.KsCategoryCard
import com.klantenstop.web.components.layout.PageLayout
import com.klantenstop.web.components.layout.PageSeoConfig
import com.klantenstop.web.styles.Typography
import com.materialkobweb.components.widgets.DsSpinner
import com.materialkobweb.components.widgets.SpinnerSize
import com.materialkobweb.styles.MaterialColorVars
import com.materialkobweb.utils.rememberViewModel
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.coroutines.flow.collectLatest
import org.jetbrains.compose.web.css.px


@Page("/categorieen")
@Composable
fun AllCategoriesPage() {
    val viewModel = rememberViewModel { AllCategoriesViewModel() }
    val state by viewModel.state.collectAsState()

    LaunchedEffect(Unit) {
        viewModel.effect.collectLatest {
            when (it) {
                else -> Unit
            }
        }
    }

    AllCategoriesPageContent(state)
}

@Composable
private fun AllCategoriesPageContent(state: AllCategoriesContract.State) {
    val breakpoint = rememberBreakpoint()

    PageLayout(
        modifier = Modifier.fillMaxSize(),
        title = "Alle categorieën",
        seo = PageSeoConfig.Managed(
            description = "Bekijk alle categorieën van dienstverleners op KlantenStop, van huisartsen tot kappers.",
            indexable = true,
            keywords = listOf("categorieën", "dienstverleners", "overzicht"),
            breadcrumbLabel = "Alle categorieën",
        ),
    ) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(topBottom = if (breakpoint >= Breakpoint.MD) 48.px else 32.px, leftRight = 24.px),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(24.px),
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .maxWidth(1120.px),
                verticalArrangement = Arrangement.spacedBy(16.px),
            ) {
                H1Heading(
                    modifier = Modifier.fillMaxWidth(),
                    text = "Alle categorieën",
                    color = MaterialColorVars.Primary.value(),
                )
                SpanText(
                    modifier = Modifier
                        .fontSize(16.px)
                        .lineHeight(24.px)
                        .color(MaterialColorVars.OnSurfaceVariant.value()),
                    text = "Alfabetisch overzicht van alle categorieën van dienstverleners op KlantenStop.",
                )
            }

            if (state.loading) {
                Box(
                    modifier = Modifier.fillMaxWidth().padding(topBottom = 48.px),
                    contentAlignment = Alignment.Center,
                ) {
                    DsSpinner(size = SpinnerSize.Normal)
                }
            } else {
                SimpleGrid(
                    modifier = Modifier
                        .fillMaxWidth()
                        .maxWidth(1120.px)
                        .gap(20.px),
                    numColumns = numColumns(1, 2, 2, 3, 4, 4)
                ) {
                    state.categories.forEach { category ->
                        KsCategoryCard(category) { text, color ->
                            // Directly under this page's H1, sized to match the old H5 look
                            H2Heading(text = text, color = color, typography = Typography.TitleMedium)
                        }
                    }
                }
            }
        }
    }
}
